import securityManager from "../../../services/managers/security";

export const onSelectedChartTypeChange = (state, action) => {
  let chartWhiteboards = state.chartWhiteboards.slice();
  let whiteboard = { ...chartWhiteboards[action.payload.whiteboardIndex] };

  let whichProperty = undefined;

  if (action.payload.whichChart === "Primary") {
    whichProperty = "selectedPrimaryChartType";
  } else if (action.payload.whichChart === "Comparison") {
    whichProperty = "selectedComparisonChartType";
  }

  if (whichProperty && whiteboard[whichProperty] !== action.payload.value) {
    whiteboard[whichProperty] = action.payload.value;
    whiteboard.__change_detection_key = securityManager.generateKey();
    chartWhiteboards[action.payload.whiteboardIndex] = whiteboard;
    return { ...state, chartWhiteboards };
  }

  return { ...state };
};



// WEBPACK FOOTER //
// ./src/store/analytics/chart-type-icons/action-handlers.js